<template>
    <div class="list-box">
		
		<Search :ifres="ifres"/>

        <Screening/>

        <div
        v-loading="loading"
        id="instance">
        <ul
        class="list"
        v-if="$store.state.dataList.length != 0">
            <li
            v-for="(i, index) in $store.state.dataList"
            :key="index"
            @click="getInside({name: i.name, shares: i.shares})">
                <div class="list-left">
                    <div class="logo">
                        <img
                        v-if="i.a104 != '暂无数据'"
                        :src="i.a104">
                        <i
                        v-else
                        class="el-icon-picture-outline"
                        style="font-size: 60px; color: #ccc;"></i>
                    </div>
                </div>

                <div class="list-right">
                    <div class="text">
                        <p v-if="i.name != '暂无数据'">{{i.name}}</p>
                        <p v-else>{{i.shares}}</p>
                        <p style="padding: 10px 0;">成立时间：{{i.dtime}}</p>
                        <p>简介：{{i.a103.trim()}}</p>
                    </div>
                </div>
            </li>
        </ul>

        <div v-else><Nodata/></div>
        </div>

        <div
        v-if="$store.state.show"
        class="page">
            <el-pagination
            background
            @current-change="handleCurrentChange"
            :current-page="$store.state.currentPage"
            :page-size="12"
            layout="total, prev, pager, next, jumper"
            :total="$store.state.total">
            </el-pagination>
        </div>
    </div>
</template>

<script>
export default {
    name: 'list',
    data() {
        return {
            radio1: '',
            radio2: '',
			edata:'',
			mdata:'',
            loading: false,
			ifres: true,
			meta: [
				{
					name: 'keywords', 
					content: 'my, page, keywords',
				}
			],
        }
    },
    created() {
        this.radio1 = this.$route.query.field
        this.radio2 = this.$route.query.category
		this.edata = this.$route.query.area
		this.mdata = this.$route.query.cit
		if  (this.$route.query.area != undefined) {
			this.getCategory2()
		}else{
			this.getCategory()
		}
        this.$store.commit('getField2', this.$route.query.field)
    },
    computed: {
        route() {
            return this.$route.fullPath;
        }
    },
    watch: {
        route() {
            this.radio1 = this.$route.query.field
            this.radio2 = this.$route.query.category
			this.edata = this.$route.query.area
			this.mdata = this.$route.query.cit
			if  (this.$route.query.area != undefined) {
				this.getCategory2()
			}else{
				this.getCategory()
			}
        }
    },
	mounted () {
		let metaInfo = {
			title: "查数字经济企业 上网经社企业库",
			keywords: "企业库，查企业，数字经济，跨境电商，产业数字化，数字零售，数字生活，在线教育，数字健康，金融科技，数字文娱",
			description: ""
		}
		this.$store.commit("CAHNGE_META_INFO", metaInfo)

	},
    methods: {
        getField() {
            this.$store.commit('deleteParameter')
            if(this.radio1 != '全部') {
                this.$store.commit('getField', ['a100', this.radio1])
            }else {
                this.$store.commit('getField', ['cate', 'all'])
            }
            this.$store.dispatch('getAxios', this.$store.state.parameter)
            this.$store.commit('getPage', 1)
        },
        getCategory() {
            this.$store.commit('deleteParameter')
            if(this.radio2 != '全部') {
                this.$store.commit('getCategory', {a: ['a100', this.radio1], b: ['a102', this.radio2]})
                this.$store.dispatch('getAxios', this.$store.state.parameter)
                this.$store.commit('getPage', 1)
            } else {
                this.getField()
            }
			
        },
		getCategory2() {
			console.log('11')
			if(this.mdata != '' && this.mdata != undefined) {
				console.log('22')
				this.$store.commit('getCategory2', {c:['a107',this.edata],d:['a108',this.mdata]})
			}else {
				console.log('33')
				this.$store.commit('getCategory2', {c:['a107',this.edata]})
			} 
			this.$store.dispatch('getAxios', this.$store.state.parameter)
			this.$store.commit('getPage', 1)
		},
        getInside(keys) {
            if(keys.name != '暂无数据') {
                window.open('/enterprise/#/Inside?name=' + keys.name)
            }else {
                window.open('/enterprise/#/Inside?shares=' + keys.shares)
            }
        },
        handleCurrentChange(val) {
            // this.loading = true
            this.$store.commit('getPage', val)
            this.$store.dispatch('getAxios', this.$store.state.parameter)
            // setTimeout(() => {
            //     this.loading = false
            // }, 500)
        },
    }
}
</script>